import { cva } from 'class-variance-authority'

import { RiskLevel } from '@/gen/inventory/v1/risk_pb'

export const iconVariants = cva('', {
  variants: {
    size: {
      icon: 'size-3.5',
      default: 'size-4',
      large: 'size-5',
    },
  },
})

export const estimatedBorderVariants = cva('!border !border-dashed !bg-transparent', {
  variants: {
    riskLevel: {
      [RiskLevel.CRITICAL]: '!border-main-foreground-danger',
      [RiskLevel.HIGH]: '!border-main-foreground-warning',
      [RiskLevel.MEDIUM]: '!border-main-foreground-attention',
      [RiskLevel.LOW]: '!border-main-foreground-secondary',
    },
  },
})

export const riskLevelDotVariants = cva('inline-block size-1.5 rounded-full', {
  variants: {
    riskLevel: {
      [RiskLevel.CRITICAL]: 'bg-main-foreground-danger',
      [RiskLevel.HIGH]: 'bg-main-foreground-warning',
      [RiskLevel.MEDIUM]: 'bg-main-foreground-attention',
      [RiskLevel.LOW]: 'bg-main-foreground-secondary',
      [RiskLevel.UNSPECIFIED]: 'bg-transparent',
    },
  },
})
